import React, { useEffect, useState } from "react";
import ListUtils from "../helpers/common/ListUtils";
import TimeFormatter from "../helpers/common/TimeFormatter";

/**
 * @param {ScorePopupArgs} param0
 */
const PuzzleScorePopup = ({ show, stats, onCloseClicked }) => {
  function getLocale() {
    const languages = ["it", "de", "pl", "es", "fr"];
    const locale = navigator.language.slice(0, 2);
    return locale != undefined && languages.includes(locale) ? locale : "it";
  }

  const [locale, setLocale] = useState(getLocale());

  useEffect(() => {
    setLocale(getLocale());
  }, []);

  const strings = {
    it: {
      congratulations: "Complimenti!",
      completed: "Hai completato il puzzle!",
      time: "Tempo: ",
      moves: "Mosse: ",
      labels: {
        hours: "ore",
        minutes: "minuti",
        seconds: "secondi",
      },
    },
    de: {
      congratulations: "Herzlichen Glückwunsch!",
      completed: "Sie haben das Puzzle gelöst!",
      time: "Zeit: ",
      moves: "Bewegt: ",
      labels: {
        hours: "Stunden",
        minutes: "Minuten",
        seconds: "Sekunden",
      },
    },
    pl: {
      congratulations: "Gratulacje!",
      completed: "ułożyłeś puzzle!",
      time: "Czas: ",
      moves: "Ruchy: ",
      labels: {
        hours: "godz.",
        minutes: "min.",
        seconds: "sek.",
      },
    },
    es: {
      congratulations: "¡Enhorabuena!",
      completed: "¡has completado el rompecabezas!",
      time: "Tiempo: ",
      moves: "Movimientos: ",
      labels: {
        hours: "horas",
        minutes: "minutos",
        seconds: "segundos",
      },
    },
    fr: {
      congratulations: "Félicitations !",
      completed: "Vous avez complété le puzzle !",
      time: "Temps: ",
      moves: "Mouvements: ",
      labels: {
        hours: "heures",
        minutes: "minutes",
        seconds: "secondes",
      },
    },
  };

  return (
    <div
      className={ListUtils.toHtmlClasses([
        "puzzle-score",
        "react-embedded-popup",
        !show ? "react-embedded-hide" : "",
      ])}
      // TODO: localization
    >
      <div className="congratulations-popup vertical-center popup-center ">
        <div
          className="congratulations-popup-title popup-txt"
          // TODO: localization
        >
          {strings[locale]["congratulations"]}
        </div>
        <div
          className="congratulations-popup-subtitle popup-txt"
          // TODO: localization
        >
          {strings[locale]["completed"]}
        </div>

        <div className="congratulations-popup-score-time popup-txt">
          {strings[locale]["time"]}:{" "}
          {TimeFormatter.formatSeconds(stats.seconds,strings[locale]["labels"])}
        </div>
        <div className="congratulations-popup-score-moves popup-txt">
          {strings[locale]["moves"]} {stats.attempts}
        </div>
      </div>

      {/* <button type="button"
                onClick={onCloseClicked}
                // TODO: localization
            >
                Ok
            </button> */}
    </div>
  );
};

export default PuzzleScorePopup;
